import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function ConfirmDeclineDialog({
  showDialog,
  declineOrder,
  onClose,
}) {
  const { t } = useTranslation();
  const [declineMessage, setDeclineMessage] = useState("");
  return (
    <Dialog
      open={showDialog}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t("orders.declineOrder")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography>{t("orders.declineOrderConfirmation")}</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label={t("orders.declineReason")}
              fullWidth
              multiline
              rows={3}
              onChange={(e) => {
                setDeclineMessage(e.target.value);
              }}
            ></TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined" autoFocus>
          {t("no")}
        </Button>
        <Button
          onClick={() => {
            declineOrder(declineMessage);
          }}
          color="secondary"
          variant="contained"
        >
          {t("yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
